const { alertMessage } = require('../common/common');

const SELECTORS = {
    resultsOrderStore: '.js-results-order-store',
    countOrderStore: '.js-count-order-store',
    filterOrderStore: '.js-filter-order-store',
    cancelOrderSuccessMessage: '#cancelOrder-successMessage',
    cancelOrderErrorMessage: '#cancelOrder-errorMessage'
};

$(document).ready(function() {

    const paramsString = window.location.search;
    const searchParams = new URLSearchParams(paramsString);
    if (searchParams.has("cancelOrder", "true")) {
        alertMessage($(SELECTORS.cancelOrderSuccessMessage).data('message'), 'cc-alert--success');
    }

    $('#DateFilter').on('change', function(e) {
        e.preventDefault();
        const url = $(this).closest('form').attr('action');
        const formData = $(this).closest('form').serialize();
        const updatedUrl = url + '?' + formData;
        $.spinner().start();

        $.ajax({
            url: updatedUrl,
            type: 'GET',
            dataType: 'json',
            success: function(data) {
                $(SELECTORS.resultsOrderStore).empty().append(data.ordersingleStoreTemplate);
                $(SELECTORS.countOrderStore).empty().text(data.total);
                $(SELECTORS.filterOrderStore).selectpicker('refresh');
                $.spinner().stop();
            },
            error: function(xhr, status, error) {
                console.error('Error occurred:', error);
            }
        });
    });
});

let cancelOrderURL;
let cancelOrderForm;
let location = window.location;

module.exports = {
    cancelOrder: function () {
        $('.cancel-order').on('click', function (e) {
            e.preventDefault();
            cancelOrderURL = $(this).data('url');
            cancelOrderForm = {orderId : $(this).data('id')};
        });
    },

    cancelOrderConfirmation: function () {
        $('.cancel-order-confirmation-btn').on('click', function (e) {
            e.preventDefault();
            $('body').spinner().start();
            $.ajax({
                url: cancelOrderURL,
                type: 'POST',
                data: cancelOrderForm,
                dataType: 'json',
                success: function (data) {
                    if (data.success) {
                        location.replace(location.href.indexOf('?') > -1 ? location.href + '&cancelOrder=true' : location.href + '?cancelOrder=true');
                    } else {
                        $('body').spinner().stop();
                        alertMessage($(SELECTORS.cancelOrderErrorMessage).data('message'), 'cc-alert--danger');
                    }
                },
                error: function (xhr, status, error) {
                    $('body').spinner().stop();
                    alertMessage($(SELECTORS.cancelOrderErrorMessage).data('message'), 'cc-alert--danger');
                }
            });
        });
    }
}